import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
import { updateProductVariations, deleteProductVariation } from '@/api/products';
import HelpText from '@/components/HelpText/index.vue';
import { getAttributesTree } from '@/api/attributes';
import FileUpload from '@/components/FileUpload/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
    this.attributesAndValues = [];
    this.productsVariations = [];
    this.showDelete = false;
    this.selectedAV = [];
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  created() {}
  activated() {
    this.getAttributesAndValues();
    this.productsVariations = this.formData.productsVariation;
    this.updateSelectedAttributeValues(this.productsVariations);
  }
  handleProductTypeChange() {
    this.$emit('updated', this.formData);
  }
  async updateSelectedAttributeValues(variations) {
    if (variations.length) {
      variations.forEach(variation => {
        if (variation.productsVariationsAttribute.length) {
          variation.productsVariationsAttribute.forEach(pva => {
            this.selectedAV.push(pva.attributeId + '_' + pva.attributesValueId);
          });
        }
      });
    }
  }
  async getAttributesAndValues() {
    try {
      let selectedAttributeIds = [];
      selectedAttributeIds = this.formData.attribute.filter(attribute => attribute).map(attribute => attribute.id);
      selectedAttributeIds = await getAttributesTree({
        attributes: JSON.stringify(selectedAttributeIds)
      });
      // add selectedValueId
      selectedAttributeIds.forEach(attributesAndValue => {
        attributesAndValue.selectedValueId = null;
      });
      this.attributesAndValues = selectedAttributeIds;
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async saveForm() {
    this.loading = true;
    try {
      const variation = await updateProductVariations(this.productsVariations);
      this.productsVariations = variation;
      this.$notify({
        title: 'Success',
        message: 'Variations saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('reload', {});
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  fileUploaded(file) {}
  resetForm() {
    this.$refs.formData.resetFields();
  }
  handleAttribute(attributesValueId, attributeId, index) {
    this.attributesAndValues[index].selectedValueId = attributesValueId;
  }
  addVariation() {
    const productId = this.formData.id;
    const attributesAndValues = [];
    let duplicateCombination = false;
    this.attributesAndValues.forEach(attributeValue => {
      const sav = attributeValue.id + '_' + attributeValue.selectedValueId;
      if (attributeValue.selectedValueId && this.selectedAV.indexOf(sav) === -1) {
        attributesAndValues.push({
          productId: productId,
          attributeId: attributeValue.id,
          attributesValueId: attributeValue.selectedValueId
        });
        this.selectedAV.push(sav);
      } else {
        if (this.selectedAV.indexOf(sav) > -1) {
          duplicateCombination = true;
        }
      }
    });
    if (duplicateCombination) {
      this.$message({
        type: 'error',
        message: 'Combination already exists!!'
      });
      return;
    }
    if (attributesAndValues.length !== this.attributesAndValues.length) {
      this.$message({
        type: 'error',
        message: 'Select attributes'
      });
      return;
    }
    const addedIndex = this.productsVariations.push({
      id: null,
      enabled: true,
      name: '',
      image: [],
      manageStock: this.formData.manageStock,
      productId: productId,
      productsVariationsAttribute: attributesAndValues,
      mrp: 0,
      stockQuantity: 0,
      shortDescription: null,
      stockStatus: this.formData.stockStatus,
      isNew: false,
      isMrpReduced: false,
      isMrpFurtherReduced: false,
      isDiscontinued: false
    }) - 1;
    this.productsVariations[addedIndex].name = this.getVariationTitle(addedIndex);
  }
  getVariationTitle(index) {
    const variationAttributesValueIds = this.productsVariations[index].productsVariationsAttribute.map(variationAttributesValue => variationAttributesValue.attributesValueId);
    const title = [];
    this.attributesAndValues.forEach(attribute => {
      attribute.attributesValues.forEach(attributesValue => {
        if (attributesValue.id === 1) {
          return true;
        }
        if (variationAttributesValueIds.indexOf(attributesValue.id) > -1) {
          title.push(attributesValue.name);
        }
      });
    });
    return title.join(' ');
  }
  editName(event, index) {
    event.preventDefault();
    this.productsVariations[index].edit = true;
  }
  saveName(event, index) {
    event.preventDefault();
    this.productsVariations[index].edit = false;
  }
  async handleDelete(event, index) {
    event.preventDefault();
    event.stopPropagation();
    const variation = this.productsVariations[index];
    try {
      await this.$confirm(this.$tc('table.deleteConfirmation', undefined, {
        name: variation.name
      }), this.$tc('table.delete'), {
        confirmButtonText: this.$tc('table.delete'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'Cancel',
        type: 'error'
      });
      if (variation.id) {
        await deleteProductVariation(variation.id);
      }
      this.productsVariations.splice(index, 1);
    } catch (error) {
      this.$message({
        type: 'info',
        message: this.$tc('table.deleteCanceled')
      });
    }
  }
};
__decorate([Prop({
  default: {}
})], default_1.prototype, "formData", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'ProductVariationTab',
  components: {
    HelpText,
    FileUpload
  }
})], default_1);
export default default_1;